'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var config = require('../common/config');
var axios = require('axios');
var FormData = require('form-data');

function checkRequiredParams(requiredList, usedList) {
    return requiredList.filter(function (name) {
        return !usedList.includes(name);
    });
}

function checkUsedLang(params) {
    if (!params.hasOwnProperty('lang')) {
        return true;
    } else {
        params.lang = config.languageMap.hasOwnProperty(params.lang) ? config.languageMap[params.lang] : params.lang;
        return config.languageList.includes(params.lang);
    }
}

function apiRequest(url, params) {

    var newParams = new FormData();
    for (var k in params) {
        newParams.append(k, _typeof(params[k]) === 'object' ? JSON.stringify(params[k]) : params[k]);
    }
    return new Promise(function (resolve, reject) {
        var _axios;

        this.cancelSource = this.cancelToken.source();
        axios((_axios = {
            method: this.requestType,
            url: url
        }, _defineProperty(_axios, this.requestType === 'get' ? 'params' : 'data', this.formDataUsage ? newParams : params), _defineProperty(_axios, 'cancelToken', this.cancelSource.token), _defineProperty(_axios, 'headers', this.headers), _axios)).then(function (response) {
            resolve(response);
        }).catch(function (error) {
            if (axios.isCancel(error)) {
                return;
            } else {
                reject(error);
            }
        }).finally(function () {
            this.cancelSource = null;
        }.bind(this));
    }.bind(this));
}

function getData(url, params) {

    return new Promise(function (resolve, reject) {
        apiRequest.bind(this)(url, params).then(function (response) {
            resolve(response);
        }.bind(this)).catch(function (error) {
            reject(error);
        });
    }.bind(this));
}

function defaultResponseParseer(response) {
    return {
        items: response.data.data,
        pagination: {
            totalItemsCount: response.data._meta ? response.data._meta.totalCount : response.data.data.length,
            totalPageCount: response.data._meta ? response.data._meta.pageCount : 1,
            perPage: response.data._meta ? response.data._meta.perPage : response.data.data.length,
            current: response.data._meta ? response.data._meta.currentPage : 1,
            hasNext: response.data._meta ? response.data._meta.currentPage < response.data._meta.pageCount : false,
            hasPrev: response.data._meta ? response.data._meta.currentPage > 1 : false
        }
    };
}

function sendRequest() {
    return new Promise(function (resolve, reject) {
        var paramsErrorList = checkRequiredParams(this.requiredMethods, this.methodsUsed);
        if (paramsErrorList.length > 0) {
            reject('Method ' + this.mainMethodName + ' have required params you don`t set - [' + paramsErrorList.join(', ') + ']');
            return;
        }
        var langCanBeUsedOrDontSet = checkUsedLang(this.requestParams);
        if (!langCanBeUsedOrDontSet) {
            reject('Method ' + this.mainMethodName + ' cant get results in this language, please use one of this languages  [' + config.languageList.join(', ') + ']');
            return;
        }

        getData.bind(this)(this.url, this.requestParams).then(function (response) {
            this.methodsUsed.forEach(function (name) {
                delete this.requestParams[this.builderParamWithRequestParamsMap[name]];
            }.bind(this));
            this.methodsUsed = [];
            resolve(this.useParser ? defaultResponseParseer(response) : response.data);
            this.cancelSource = null;
        }.bind(this)).catch(function (error) {
            reject(error);
        });
        this.requestParams = Object.assign({}, this.defaultParams);
    }.bind(this));
}

function cancelRequest() {
    if (this.cancelSource) {
        this.cancelSource.cancel();
    }
}

module.exports = {
    send: sendRequest,
    cancel: cancelRequest
};